import classNames from "classnames";

function Layout({ children, className, centered }) {
  return (
    <div className={classNames("acoris__main", className)}>
      <div
        className={classNames("acoris__container", {
          "acoris__container--centered": centered,
        })}
      >
        <div
          className={classNames("acoris__wrapper", {
            "acoris__wrapper--centered": centered,
          })}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;
